import React, { FC, useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation } from 'react-router-dom';
import SoftwareFilesSection from '../software-files';
import useStyles from './styles';
import ConfigFilesSection from '../communicator-files';
import StandardParameterConfigSection from '../standard-parameter-config';
import SubscriptionCatalog from '../subscription-catalog';
import VIMSAndRTDSConfig from '../vims-rtds-config';
import PanelConfigurations from '../panel-configurations';

type AccordionItem = { title: string; open: boolean; component: FC<{}> };
type AccordionData = { title: string; data: AccordionItem[] }[];

const sections = [
  {
    title: '',
    data: [
      { title: 'Software Files', open: false, component: SoftwareFilesSection },
      { title: 'Standard Parameter Config File Library', open: false, component: StandardParameterConfigSection},
      { title: 'Communicator Files', open: false, component: ConfigFilesSection },
      { title: 'Subscription Catalog', open: false, component: SubscriptionCatalog },
      { title: 'VIMS AND RTDS CONFIG', open: false, component: VIMSAndRTDSConfig },  
      { title: 'PANEL CONFIGURATIONS', open: false, component: PanelConfigurations },
    ],
  },
];

const LibraryAccordions: FC<{}> = () => {
  const classes = useStyles();
  const [accordionData, setAccordionData] = useState<AccordionData>(sections);
  const toggleOpen = (sectionIterator: number, componentIterator: number) => {
    const toggledCopy = [...accordionData];
    toggledCopy[sectionIterator].data[componentIterator].open = !accordionData[sectionIterator]
      .data[componentIterator].open;
    setAccordionData(toggledCopy);
  };
  const location = useLocation();

  useEffect(()=> {
      setAccordionData(
        accordionData.map(accordion => ({
          ...accordion,
          data: accordion.data.map((data) => ({
            ...data,
            open: false
          }))
        })
      ));
  }, [location.pathname]);

  return (
    <div className={classes.accordions}>
      {accordionData.map((section, sectionIterator) => (
        <>
          <Box>
            <Typography variant="h6">{section.title}</Typography>
          </Box>
          {section.data.map((componentContainer, componentIterator) => (
            <Accordion
              id={`${componentContainer.title}Panel`}
              expanded={componentContainer.open}
              onChange={() => toggleOpen(sectionIterator, componentIterator)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
              >
                <Typography variant="h5">{componentContainer.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {componentContainer.open && <componentContainer.component />}
              </AccordionDetails>
            </Accordion>
          ))}
        </>
      ))}
    </div>
  );
};

export default LibraryAccordions;
